import { render, staticRenderFns } from "./DetailBarang.vue?vue&type=template&id=1acae89b&scoped=true&"
import script from "./DetailBarang.vue?vue&type=script&lang=js&"
export * from "./DetailBarang.vue?vue&type=script&lang=js&"
import style0 from "./DetailBarang.vue?vue&type=style&index=0&id=1acae89b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1acae89b",
  null
  
)

export default component.exports